<template>
    <div class="location">
        
        <div class="loc_left">
          <motion v-bind:zoomsize="zoomsizes" @setzoomsize="setzoomsizes" :index="indexs" :btn="true">

            <div class="middle"  style="width: 100%; height: 100%;">
                <img
                    style="max-width: 95%;max-height: 98%;"
                    :src="Main.imgserve+'/LOCATION/map.png'"
                    draggable="false"
                    alt=""
                />
            </div>
        </motion>
        <div style="position: absolute;right: 10vw;bottom: 2vh;    height: 15vh;
    width: 15vw;"
        ><img :src="Main.imgserve+'/LOCATION/MRT.png'" alt=""></div>
        <div style="position: absolute;left: 5vw;bottom: 2vh;    height: 15vh;
    width: 15vw;"
        ><img :src="Main.imgserve+'/LOCATION/NT.png'" alt=""></div>
            <!-- <img  :src="Main.imgserve+'/LOCATION/map.png'" alt=""> -->
        </div>
        <div class="loc_right">
            <img :src="Main.imgserve+'/LOCATION/mapright.png'" alt="">
        </div>
            <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">LOCATION MAP</h2>
    </div>
    </div>
</template>

<script>
import motion from "@/components/motion.vue";

export default {
      	  components: {
        motion,
      },
    data() {
        return {
            zoomsizes: 1,
			indexs:0,
        }
    },
    methods:{
        setzoomsizes(data) {
            // 缩放组件回调
      this.zoomsizes = data;
    },
    },
    mounted(){

    }
}
</script>

<style lang="less">
    
.location{
    width: 100%;
    height: 100%;
    margin: 0;
    .loc_left{
    width: 65%;
    height: 100%;
    display: flex;
    justify-content: center;
    /* flex-flow: column; */
    align-items: center;
    position: relative;

    }
    .loc_right{
    position: fixed;
        // bottom: 2vh;
        top: 16vh;
        right: 5vw;
        width: 25vw;
    }
}


</style>